<div class="modal">
  <div class="close-link">
    <span class="close" [mat-dialog-close]></span>
  </div>
  <h1 class="modal__title">{{ 'pages.restaurantAccount.editIntegration' | translate }}</h1>

  <div *ngIf="loading" class="loader">
    <mat-spinner class="spinner" diameter="150"></mat-spinner>
  </div>

  <ng-container *ngIf="this.integration?.provider === 'VAST'">
    <app-edit-integration-vast [data]="integration" (remove)="removeIntegration()" (edited)="editIntegration($event)"></app-edit-integration-vast>
  </ng-container>

  <ng-container *ngIf="this.integration?.provider === 'vistarMedia'">
    <app-edit-integration-vistar [data]="integration" (remove)="removeIntegration()" (edited)="editIntegration($event)"></app-edit-integration-vistar>
  </ng-container>

  <ng-container *ngIf="this.integration?.provider === 'kelseysMenu'">
    <app-edit-integration-kelseys-menu [data]="integration" (remove)="removeIntegration()" (edited)="editIntegration($event)"></app-edit-integration-kelseys-menu>
  </ng-container>

  <ng-container *ngIf="this.integration?.provider === 'bostonPizzaUI'">
    <app-edit-integration-bp-ui [data]="integration" (remove)="removeIntegration()" (edited)="editIntegration($event)"></app-edit-integration-bp-ui>
  </ng-container>

  <ng-container *ngIf="this.integration?.provider === 'bostonPizzaEventsAPI'">
    <app-edit-integration-bp-events-api [data]="integration" (remove)="removeIntegration()" (edited)="editIntegration($event)"></app-edit-integration-bp-events-api>
  </ng-container>

  <ng-container *ngIf="this.integration?.provider === 'foyr'">
    <app-edit-integration-foyr [data]="integration" (remove)="removeIntegration()" (edited)="editIntegration($event)"></app-edit-integration-foyr>
  </ng-container>
</div>
